import React, { Dispatch, SetStateAction, useContext, useEffect } from 'react';
import styles from './SelectLocation.module.css';
import { AnyIfEmpty, useDispatch } from 'react-redux';
import { getLocation } from '../../../../redux/location/actions/location.action';
import { AppDispatch } from '../../../../redux/rootReducer';
import { AvailabilityRedirectionContext } from '../../../context/availabilityRedirection';

interface AddAvailabilityObjProps {
    closingTime: string;
    endDate: string;
    locationId: string;
    locationName: string;
    locker: number | null;
    openingTime: string;
    startDate: string;
    unitId: string;
    unitName: string;
}

interface SelectLocationProps {
    setShowLocation: Dispatch<SetStateAction<boolean>>;
    setShowUnits: Dispatch<SetStateAction<boolean>>;
    setAddAvailabilityObj: Dispatch<SetStateAction<AddAvailabilityObjProps>>;
    AvailabilityList: string[];
    addAvailabilityObj: AddAvailabilityObjProps;
}

const SelectLocation = ({
    setShowLocation,
    setShowUnits,
    setAddAvailabilityObj,
    AvailabilityList,
    addAvailabilityObj,
}: SelectLocationProps) => {
    const availabilityRedirectionContext = useContext(AvailabilityRedirectionContext);

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h2 className={styles.title}>Add Availability</h2>
            </div>
            <div className={styles.body}>
                <h3 className={styles.subTitle}>Select a property</h3>
                <div className={styles.tabs}>
                    {AvailabilityList &&
                        AvailabilityList.map((location: AnyIfEmpty<object>) => (
                            <span
                                onClick={() => {
                                    availabilityRedirectionContext?.setAvailabilityData({
                                        locationId: '',
                                        locationName: '',
                                        selectedDate: '',
                                        slotRange: '',
                                        unitId: '',
                                        unitName: '',
                                        lockerNumber: 0,
                                    });
                                    setAddAvailabilityObj((prevState: AddAvailabilityObjProps) => {
                                        return {
                                            ...prevState,
                                            locationId: location.id,
                                            locationName: location.name,
                                            unitId: prevState.locationId !== location.id ? '' : addAvailabilityObj.unitId,
                                            unitName: prevState.locationId !== location.id ? '' : addAvailabilityObj.unitId,
                                        };
                                    });
                                    setShowLocation(false);
                                    setShowUnits(true);
                                }}
                                key={location.id}
                                className={location.id === addAvailabilityObj.locationId ? styles.selected : styles.tab}>
                                {location.name}
                            </span>
                        ))}
                </div>
            </div>
        </div>
    );
};

export default SelectLocation;
